<div class="modal-content">
  <div class="modal-body p-4">
    <p class="mb-45">{{ 'INSCRIPTIONS.WaitingList.Subtitle' | translate }}</p>
    <form [formGroup]="form()">
      <div class="row g-45">
        <div class="col-md-6 col-12">
          <p-floatLabel>
            <input pInputText id="nom" type="text" class="w-100" formControlName="nom" />
            <label for="nom">{{ 'Name' | translate }} *</label>
          </p-floatLabel>
        </div>
        <div class="col-md-6 col-12">
          <p-floatLabel>
            <input pInputText id="cognom" type="text" class="w-100" formControlName="cognom" />
            <label for="cognom">{{ 'Surnames' | translate }} *</label>
          </p-floatLabel>
        </div>
        <div class="col-md-6 col-12">
          <p-floatLabel>
            <input pInputText id="email" type="email" class="w-100" formControlName="email" />
            <label for="email">Email *</label>
          </p-floatLabel>
        </div>
        <div class="col-md-6 col-12">
          <p-floatLabel class="p-float-label-active">
            <app-custom-field-phone id="phone" name="phone" formControlName="telefon" [attr.aria-label]="'Phone' | translate" />
            <label for="phone">{{ 'Phone' | translate }} *</label>
          </p-floatLabel>
        </div>
        @if (hasMultiplePrices()) {
          <div class="col-md-6 col-12">
          <p-floatLabel>
            <p-dropdown
              id="price"
              class="w-100"
              [options]="priceOptions()"
              optionLabel="name"
              formControlName="price"
              appendTo="body"
              [optionValue]="'id'"
              [dataKey]="'id'"
              placeholder="{{ 'TICKETS.SelectEntryType' | translate }}"
            />
            <label for="price">{{ 'TICKETS.EntryType' | translate }} *</label>
          </p-floatLabel>
          </div>
        }
        <div class="col-md-6 col-12">
          <p-floatLabel>
            <input
              pInputText
              id="persones"
              type="number"
              class="w-100"
              min="1"
              [max]="maxTickets()"
              formControlName="persones"
            />
            <label for="persones">{{ 'WAITINGLIST.npersons' | translate }} * @if (showMaxTicketsLabel) { (max: {{ maxTickets() }}) }</label>
          </p-floatLabel>
        </div>
      </div>
    </form>
    <app-button-loading
      class="mt-4 fw-500 rounded text-white"
      [style]="'--corp-color:' + color + ';'"
      [text]="'WAITINGLIST.ButtonWaitingList' | translate"
      [icon]="'fa fa-save'"
      [customClass]="'rounded corp-color text-white'"
      [disabled]="form()?.invalid"
      [actionAsync]="onSubmit"
    >
    </app-button-loading>
  </div>
</div>
